import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CompaniesPage } from './pages/CompaniesPage';
import { CompanyPage } from './pages/CompanyPage';
import { DashboardPage } from './pages/DashboardPage';
import { EventsPage } from './pages/EventsPage';
import { JobsPage } from './pages/JobsPage';
import { DeskPage } from './pages/DeskPage';
import { ResearchPage } from './pages/ResearchPage';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="companies/:slug" element={<CompanyPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="research" element={<ResearchPage />} />
        <Route path="desk" element={<DeskPage />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
    </Routes>
  );
}
